import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions, RowNodeBlock } from 'ag-grid';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import * as encoding from 'encoding-japanese';
import { PickService } from '../../../service/pick/pick.service';
import { StPickService } from '../../../service/st-pick/st-pick.service';
import { ShipService } from '../../../service/ship/ship.service';
import { ClientReportService } from '../../../service/client-report/client-report.service';
import { PdfReportService } from '../../../service/pdf-report/pdf-report.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { HeaderComponent } from '../../../../app/menu/header/header.component';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { PostDataSource } from '../../../classes/dataSource/postDataSource';

@Component({
  selector: 'app-root',
  templateUrl: 'wa3030.component.html',
  styleUrls: ['wa3030.component.scss']
})
export class Wa3030Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA3030:出荷検品照会';
  public updprogramCd = 'WA3030';

  @ViewChild(HeaderComponent)
  private headerComponent: HeaderComponent;
  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];
  public ownerId: number;
  public ownerResult: any;
  public config = config;
  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  public reporttrnId: number;
  private reportOpened = false;
  private reportTry = 0;
  public excelFl = 0;
  private errorInfo = '';
  private postDataSource: PostDataSource;
  private isOwnerLinked: boolean = false;

  @ViewChild('gridView')
  gridView: ElementRef;
  private gridHelper: AgGridHelper;

  private searchValue1 = null;
  private searchValue2 = null;
  private searchValue3 = null;
  private searchValue4 = null;
  private startDate = null;
  private endDate = null;
  public stpicks: any[];
  public stpick = '';

  private isShowSearchBlock = true;

  private isEnableClearFilterButton = false;
  private isShowRemoveModal = false;
  private isEnableRightAreaButtons = false;
  private url;

  /** pagination */
  private totalCount = 0;
  private selectedCount = 0;
  private currentPage = 0;
  private maxPage = 0;
  public rowsPerPageModel = [{ value: 500, viewValue: '500' }, { value: 5000, viewValue: '5000' }, { value: 50000, viewValue: '50000' }];
  public rowsPerPage = config.rowsPerPageSize;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;

  private tabIndex = 0;
  private isTab1CheckboxChecked = false;
  private isPrintClientReportBySelectedButtonEnabled = false;

  public checkbox: boolean;
  public stpickId: number;
  public typepickCd: string;

  private originalRowData: any[];
  private paginationGetRowCount = 0;
  private isShowSendLoading = false;
  private selectAllModifyStatusOnleFlg = false;

  private isDatasourceInit = false; 
 
  constructor(
    private router: Router,
    private pickService: PickService,
    private stPickService: StPickService,
    private clientReportService: ClientReportService,
    private pdfReportService: PdfReportService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private shipService: ShipService
  ) {
    const result = JSON.parse(sessionStorage.getItem('loginResult'));
    const querystrings = this.ownerId ? { ownerId: this.ownerId } : '';
    //SessionStorageからユーザ情報を取得、荷主ユーザか判定
    if (result !== null) {
      let user = result.user;
      this.isOwnerLinked = user.roleId == 3 ? true : false;
    }
    this.postDataSource = new PostDataSource({
      parent: this,
      service: this.pickService,
      resultKey: 'picks',
      querystrings: querystrings,
      beforeRequest: this.handleBeforeRequest.bind(this),
      successCallback: this.handleRequestSucc.bind(this)
    });
    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowModelType: 'infinite',
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      enableServerSideSorting: true,
      enableServerSideFilter: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      cacheBlockSize: Number(this.rowsPerPage),
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa3030_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.fixedDateFilterInput();
        this.fixedSelectAll()
      },
      onFilterChanged: () => {
        this.isEnableClearFilterButton = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
        //選択全解除
        this.gridOptions.api.deselectAll();
        this.errorInfo = '';
      },
      onRowDataChanged: () => {
        this.gridHelper.onRowDataChanged();
        this.errorInfo = '';
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.gridHelper.fixedAgMenu();
        this.errorInfo = '';
      },
      onSortChanged: () => {
        this.gridHelper.renderGridCheckboxImage();
        //ボタン非活性
        this.isEnableRightAreaButtons = false;
        //ソート時は選択状態の解除
        this.gridOptions.api.deselectAll();
        this.errorInfo = '';
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
        console.log('選択行数（this.selectedCount）', this.selectedCount);
      },
      onPaginationChanged: () => {
        if (this.postDataSource['init'] == false) return;
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
        this.gridHelper.onRowDataChanged();
        // this.selectedCount = 0
        this.selectAllClick()
        console.log('選択行数（this.selectedCount）', this.selectedCount);
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        suppressMenu: true,
        pinned: 'left'
      },
      {
        headerName: '',
        field: 'col1Scroll:225',
        suppressMenu: true,
        width: 8,
        cellClass: ['tc', 'cellclass'],
        hide: true,
        pinned: 'left',
        cellStyle: function (params) {
          //ステータス色変化
          if (params.data.stpickTx == '印刷可') {
            return { backgroundColor: 'rgba(235,153,175,0.2)', color: '#eb99af' };
          } else if (params.data.stpickTx == 'ピック開始') {
            return { backgroundColor: 'rgba(227,230,87,0.2)', color: 'rgba(227,230,87,0.2)' };
          } else if (params.data.stpickTx == '梱包完了') {
            return { backgroundColor: 'rgba(201,202,202,0.2)', color: 'rgba(201,202,202,0.2)' };
          } else {
            return null;
          }
        }
      },
      /*
      {
        headerName: 'ピッキングID',
        field: 'pickId',
        width: this.getColumnWidth('pickId', 50),
        cellClass: 'rightaligned'
      },
      */
      {
        headerName: 'ピッキングステータス',
        field: 'stpickTx',
        width: this.getColumnWidth('stpickTx', 150),
        suppressMenu: true,
        cellClass: ['tc', 'cellclass'],
        cellStyle: function (params) {
          //ステータス色変化
          if (params.value == '印刷可') {
            return { backgroundColor: 'rgba(235,153,175,0.2)' };
          } else if (params.value == 'ピック開始') {
            return { backgroundColor: 'rgba(227,230,87,0.2)' };
          } else if (params.value == '梱包完了') {
            return { backgroundColor: 'rgba(201,202,202,0.2)' };
          } else {
            return null;
          }
        }
      },
      {
        headerName: 'マルチ組番号',
        field: 'multiCd',
        width: this.getColumnWidth('multiCd', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'フロア',
        field: 'floorCd',
        width: this.getColumnWidth('floorCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '指示書番号',
        field: 'picknoCd',
        sort: 'desc',
        width: this.getColumnWidth('picknoCd', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '明細番号',
        field: 'pickdetnoCd',
        sort: 'desc',
        width: this.getColumnWidth('pickdetnoCd', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '出荷番号',
        headerTooltip: '出荷番号',
        field: 'shipnoCd',
        width: this.getColumnWidth('shipnoCd', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '受注番号',
        headerTooltip: '受注番号',
        field: 'ordernoCd',
        width: this.getColumnWidth('ordernoCd', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '種別',
        field: 'typepickTx',
        width: this.getColumnWidth('typepickTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '配送キャリア名',
        field: 'carrierTx',
        width: this.getColumnWidth('carrierTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '配送区分',
        field: 'delitypeshortTx',
        width: this.getColumnWidth('delitypeshortTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先コード',
        field: 'dtaddressCd',
        width: this.getColumnWidth('dtaddressCd', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先名',
        field: 'dtnameTx',
        width: this.getColumnWidth('dtnameTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケーション名',
        field: 'locaTx',
        width: this.getColumnWidth('locaTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        width: this.getColumnWidth('itemCd', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロット',
        field: 'lotTx',
        width: this.getColumnWidth('lotTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '使用期限',
        field: 'uselimitDt',
        width: this.getColumnWidth('uselimitDt', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '単位名',
        field: 'unitTx',
        width: this.getColumnWidth('unitTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入数',
        field: 'amountNr',
        width: this.getColumnWidth('amountNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '数量',
        field: 'pickpcsNr',
        width: this.getColumnWidth('pickpcsNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ピック開始日時',
        field: 'pickstartDt',
        width: this.getColumnWidth('pickstartDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ピック終了日時',
        field: 'pickendDt',
        width: this.getColumnWidth('pickendDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ピックユーザー名',
        field: 'pickuserTx',
        width: this.getColumnWidth('pickuserTx', 200),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      /*
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 100),
        hide: true
      },
      */
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      } /*,
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 100),
        hide: true
      }*/
    ];
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonTripleMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.gridHelper.setGridOptions(this.gridOptions);
  }
  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa3030_${id}_width`), 10) || def;
  }
  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa3030_${params.column.colId}_width`, params.column.actualWidth);
    }
  }
  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa3030_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }
  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };
    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };
    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'チェックした行をExcelエクスポート',
            action: () => {
              params.api.exportDataAsExcel({ onlySelected: true });
            }
          }
        ]
      }
    ];
    return result;
  }
  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    var date = new Date();
    var filters = {};

    this.stPickService
      .get()
      .then(response => {
        console.log(response);
        this.stpicks = response['stpicks'];
      })
      .catch(error => {
        this.stpicks = [];
      });

    setTimeout(() => {
      this.startDate = date.getFullYear() + '-' + this.pad(date.getMonth() + 1, 2) + '-' + this.pad(date.getDate(), 2);
      this.typepickCd = '10';
      filters['typepickTx'] = {
        type: 'equals',
        filter: 'オーダーピック'
      };
      this.gridApi.api.setFilterModel(filters);
    }, config.waitMsForSearchInNgAfterViewInit);
  }
  pad(num, totalStringSize) {
    var asString = num + '';
    while (asString.length < totalStringSize) asString = '0' + asString;
    return asString;
  }
  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }
  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonTripleMargin;
  }

  changeOwner(selectedOwnerId) {
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];
      this.originalRowData = [];
      this.gridOptions.api.deselectAll();
    }
  }
  onFilterClear() {
    this.errorInfo = '';
    //ボタン非活性
    this.isEnableRightAreaButtons = false;
    //this.gridOptions.api.setFilterModel(null);
    this.searchByKey({});
  }

  printonly() {
    this.checkbox = this.checkbox.valueOf();
    this.onSubmit();
  }

  searchByKey(filters) {

    if (this.ownerId != null) {
      filters['ownerId'] = {
        type: 'contains',
        filter: this.ownerId
      };
    }
    //選択タブにより切り替え
    var typePickTx = '';
    switch (this.tabIndex) {
      case 0:
        typePickTx = 'オーダーピック';
        this.typepickCd = '10';
        break;
      case 1:
        typePickTx = 'ケースピック';
        this.typepickCd = '30';
        break;
    }
    filters['typepickTx'] = {
      type: 'equals',
      filter: typePickTx
    };

    if (this.searchValue1 != null && this.searchValue1.length > 0) {
      filters['picknoCd'] = {
        type: 'contains',
        filter: this.searchValue1
      };
    }

    if (this.searchValue2 != null && this.searchValue2.length > 0) {
      filters['itemCd'] = {
        type: 'contains',
        filter: this.searchValue2
      };
    }

    if (this.searchValue3 != null && this.searchValue3.length > 0) {
      filters['itemTx'] = {
        type: 'contains',
        filter: this.searchValue3
      };
    }

    if (this.searchValue4 != null && this.searchValue4.length > 0) {
      filters['dtnameTx'] = {
        type: 'contains',
        filter: this.searchValue4
      };
    }

    if (this.stpick != null && this.stpick.length > 0) {
      filters['stpickTx'] = {
        type: 'equals',
        filter: this.stpicks[this.stpick]['stpickTx']
      };
      this.stpickId = this.stpicks[this.stpick]['stpickId']
    } else {
      this.stpickId = null
    }

    if (Object.getOwnPropertyNames(filters).length == 0) {
      this.gridApi.api.setFilterModel(null);
      return
    }
    this.gridApi.api.setFilterModel(filters);
  }

  clearSearchKey() {
    this.errorInfo = '';

    this.searchValue1 = null;
    this.searchValue2 = null;
    this.searchValue3 = null;
    this.searchValue4 = null;
    this.startDate = null;
    this.endDate = null;
    this.stpick = '';
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    //this.gridOptions.api.showLoadingOverlay();

    //if (this.checkbox) {
    //  this.stpickId = 9;
    //} else {
    //  this.stpickId = undefined;
    //}

    switch (this.tabIndex) {
      case 0:
        this.typepickCd = '10';
        break;
      case 1:
        this.typepickCd = '30';
        break;
    }

    this.postDataSource['querystrings'] = {
      ownerId: this.ownerId,
      stpickId: this.stpicks[this.stpick] && this.stpicks[this.stpick]['stpickId'] || null,
      typepickCd: this.typepickCd,
      picknoCd: this.searchValue1,
      itemCd: this.searchValue2,
      itemTx: this.searchValue3,
      dtnameTx: this.searchValue4,
      startDate: this.startDate,
      endDate: this.endDate
    }
    this.searchByKey({});
    if (!this.isDatasourceInit) {
      this.gridOptions.api.setDatasource(this.postDataSource);
      this.isDatasourceInit = true
    }

  }
  print(reportCd: string) {
    if (this.gridOptions.api.getSelectedRows().length === 0) {
      this.isShowSendLoading = false;
      this.errorInfo = '対象を選択して下さい';
      return;
    }
    this.printPDF(reportCd);
  }

  printPickDispatcher() {
    this.errorInfo = '';
    if (this.gridOptions.api.getSelectedRows().length === 0) {
      return;
    }
    if (this.tabIndex == 0) this.printOrderPick();
    else this.printCasePick();
  }

  printOrderPick() {
    if (this.gridOptions.api.getSelectedRows().length === 0) {
      this.isShowSendLoading = false;
      this.errorInfo = '対象を選択して下さい';
      return;
    }

    let selectedRows = this.gridOptions.api.getSelectedRows();
    const orderPickInst = selectedRows.some(e => !e.multiCd);
    const multiPickInst = selectedRows.some(e => e.multiCd);
    if(orderPickInst && multiPickInst){
      this.isShowSendLoading = false;
      this.errorInfo = 'ピック方法が異なる指示が選択されているため、指示書を出力できません。';
      return;
    }

    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    //選択された指示書を取得
    this.isShowSendLoading = true;
    const selectIds: object[] = [];
    const result = [];

    for (let i = 0; i < this.gridOptions.api.getSelectedRows().length; i++) {
      var data = this.gridOptions.api.getSelectedRows()[i];
      if (data['stpickId'] < 9) {
        this.isShowSendLoading = false;
        this.working = false;
        this.errorInfo = '緊急補充未完了の指示は出力できません';
        return;
      }
      const jsonUnit: object = {
        selectId: data['picknoCd']
      };
      selectIds.push(jsonUnit);
    }
    // 複数選択された時を考慮
    let arrObj = {};
    for (let i = 0; i < selectIds.length; i++) {
      arrObj[selectIds[i]['selectId']] = selectIds[i];
    }
    //チェックすべき指示書を特定
    for (var key in arrObj) {
      this.gridOptions.api.forEachNode(function(rowNode){

         if (rowNode.data.pickNoCd === key) result.push(rowNode.data);
      });
    }

    // ピッキング指示書
    if(orderPickInst){
        this.printPDF('RA3006');
    }
    else if(multiPickInst){
        this.printMutliPickPDF('RA3012');
    }
  }

  printCasePick() {
    if (this.gridOptions.api.getSelectedRows().length === 0) {
      this.isShowSendLoading = false;
      this.errorInfo = '対象を選択して下さい';
      return;
    }
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    // 選択された指示書を取得
    this.isShowSendLoading = true;
    const selectIds: object[] = [];
    const result = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedRows().length; i++) {

      var data = this.gridOptions.api.getSelectedRows()[i];
      if (data['stpickId'] < 9) {
        this.isShowSendLoading = false;
        this.working = false;
        this.errorInfo = '緊急補充未完了の指示は出力できません';
        return;
      }
      const jsonUnit: object = {
        selectId: data['picknoCd']
      };
      selectIds.push(jsonUnit);
    }
    // 複数選択された時を考慮
    let arrObj = {};
    for (let i = 0; i < selectIds.length; i++) {
      arrObj[selectIds[i]['selectId']] = selectIds[i];
    }
    // チェックすべき指示書を特定
    for (var key in arrObj) {
      this.gridOptions.api.forEachNode(function(rowNode){
        if (rowNode.data.pickNoCd === key) result.push(rowNode.data);
      });
    }
    // ケースピッキング指示書
    this.printPDF('RA3002');
  }

  // クライアント帳票出力
  printClientReport(reportCd: string) {
    this.isShowSendLoading = true;
    this.errorInfo = '';
    if (this.gridOptions.api.getSelectedRows().length === 0) {
      this.isShowSendLoading = false;
      this.errorInfo = '対象を選択して下さい';
      return;
    }
    this.isShowSendLoading = true;
    let carrierCd = '';
    switch (reportCd) {
      case 'RC0101':
        carrierCd = '1001';
        break;
      case 'RC0201':
        carrierCd = '1002';
        break;
      case 'RC0401':
        carrierCd = '1004';
        break;
      case 'RC0901':
        carrierCd = '1009';
        break;
      case 'RC5101':
        carrierCd = '1051';
        break;
      case 'RC9901':
        // 個口ラベルは配送会社またぎで印刷可能とする
        carrierCd = '';
        break;
      default:
        this.isShowSendLoading = false;
        this.errorInfo = '予期せぬエラー：未定義の帳票コードです';
        return;
    }
    let ownerId = 0;
    const selectIds: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedRows().length; i++) {

      var data = this.gridOptions.api.getSelectedRows()[i];
      // check carrier
      // 個口ラベルは配送会社またぎで印刷可能とする
      if (reportCd !== 'RC9901') {
        if (data['carrierCd'] !== carrierCd) {
          this.isShowSendLoading = false;
          this.errorInfo = '異なる配送会社の指示が選択されています。対象の配送会社の指示のみ選択してください';
          return;
        }
      }
      // check owner
      if (ownerId !== 0) {
        if (data['ownerId'] !== ownerId) {
          this.isShowSendLoading = false;
          this.errorInfo = '複数荷主の指示が選択されています。同一荷主の指示のみ選択してください';
          return;
        }
      } else {
        ownerId = data['ownerId'];
      }
      // push data
      const jsonUnit: object = {
        selectId: data['shiphId']
      };
      selectIds.push(jsonUnit);
    }

    this.clientReportService
      .post(ownerId, reportCd, '', this.updprogramCd, selectIds)
      .then(outputJson => {

        this.isShowSendLoading = false;
        for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
          this.gridOptions.api.getSelectedNodes()[i].setSelected(false);
        }
        sessionStorage.setItem('SuccessInfoMessage', '印刷処理が完了しました。');
      })
      //一次テーブル登録でエラー
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.isShowSendLoading = false;
      });
  }

  printClientReportBySelected() {
    this.isShowSendLoading = true;
    this.errorInfo = '';
    if (!this.isPrintClientReportBySelectedButtonEnabled) return;
    if (this.gridOptions.api.getSelectedRows().length === 0) {
      this.isShowSendLoading = false;
      this.errorInfo = '対象を選択して下さい';
      return;
    }
    let carrierCd = '';

    let ownerId = 0;
    const selectIds: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedRows().length; i++) {

      var data = this.gridOptions.api.getSelectedRows()[i];

      if (carrierCd === '') carrierCd = data['carrierCd'];

      // check owner
      if (ownerId !== 0) {
        if (data['ownerId'] !== ownerId) {
          this.isShowSendLoading = false;
          this.errorInfo = '複数荷主の指示が選択されています。同一荷主の指示のみ選択してください';
          return;
        }
      } else {
        ownerId = data['ownerId'];
      }
      // push data
      const jsonUnit: object = {
        selectId: data['shiphId']
      };
      selectIds.push(jsonUnit);
    }

    var reportCd = 'RC' + carrierCd.substring(2) + '01';
    this.clientReportService
      .post(ownerId, reportCd, '', this.updprogramCd, selectIds)
      .then(outputJson => {
        for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
          this.gridOptions.api.getSelectedNodes()[i].setSelected(false);
        }
        sessionStorage.setItem('SuccessInfoMessage', '印刷処理が完了しました。');
        this.isShowSendLoading = false;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.isShowSendLoading = false;
      });
  }
  // PDF出力
  printMutliPickPDF(reportCd: string) {
    this.isShowSendLoading = true;
    this.reportOpened = false;
    this.reporttrnId = 0;
    this.reportTry = 0;
    let selectIdSet = new Set<string>();
    let selectedRows = this.gridOptions.api.getSelectedRows();
    selectedRows.forEach(function (selectedRow, index) {
      selectIdSet.add(selectedRow.multiCd);
    });

    let sortedIdSet = new Set<string>();
    this.gridOptions.api.forEachNode(function(rowNode){
      if (selectIdSet.has(rowNode.data.multiCd)) {
        sortedIdSet.add(rowNode.data.multiCd);
      }
    });
    this.pdfReportService
      .postSpring(reportCd, this.updprogramCd, sortedIdSet)
      .then(outputJson => {
        const pdfFilename = outputJson.pdfFilename;
        const popup_window = window.open(environment.pdfPath + pdfFilename);
        this.selectedCount = 0;
        this.isShowSendLoading = false;
        this.working = false;
        this.onSubmit();
        this.url = environment.pdfPath + pdfFilename;
        try {
          popup_window.focus();
        } catch (e) {
          this.isShowRemoveModal = true;
        }
      })
      .catch(error => {
        this.isShowSendLoading = false;
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  // PDF出力
  printPDF(reportCd: string) {
    this.isShowSendLoading = true;
    this.reportOpened = false;
    this.reporttrnId = 0;
    this.reportTry = 0;


    //グリッドデータのLoadingステータス確認（Loadedでない場合は処理を開始しない）
    this.checkCacheState().then(result =>{

        let selectIdSet = new Set<string>();
        let selectedRows = this.gridOptions.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
          selectIdSet.add(selectedRow.picknoCd);
        });

        let sortedIdSet = new Set<string>();
        this.gridOptions.api.forEachNode(function(rowNode){
          if (selectIdSet.has(rowNode.data.picknoCd)) {
            sortedIdSet.add(rowNode.data.picknoCd);
          }
        });

        //ボタン非活性
        this.isEnableRightAreaButtons = false;

        this.pdfReportService
        .postSpring(reportCd, this.updprogramCd, sortedIdSet)
        .then(outputJson => {
          const pdfFilename = outputJson.pdfFilename;
          const popup_window = window.open(environment.pdfPath + pdfFilename);
          this.selectedCount = 0;
          this.isShowSendLoading = false;
          this.working = false;
          this.onSubmit();
          this.url = environment.pdfPath + pdfFilename;
          try {
            popup_window.focus();
          } catch (e) {
            this.isShowRemoveModal = true;
          }
        })
        .catch(error => {
          this.isShowSendLoading = false;
          this.working = false;
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
   }).catch(error => {
      this.isShowSendLoading = false;
      this.working = false;
      this.errorInfo = '表示データが読み込み中であったため指示書出力を中止しました。再試行してください。';
    });

  }

    // ヘッダ表示をデータ取得中の状態に変更
    setHeaderLoadingStart () {
      // ヘッダを非表示にする
      this.gridView.nativeElement.querySelector('.ag-header').style.display = 'none';
      // スクロールバーを表示しない
      this.gridView.nativeElement.querySelector('.ag-body-viewport').style.overflow = 'hidden';
      // 念のためフィルターの入力を不可にする
      var filterInput = this.gridView.nativeElement.querySelectorAll('.ag-header-cell input, .ag-header-cell button');
      for(let i in filterInput){
        if (filterInput.hasOwnProperty(i)) {
          filterInput[i].disabled = true;
        }
      }
    }

    // ヘッダ表示をデータ取得中の状態から戻す
    setHeaderLoadingEnd () {
      // ヘッダの表示を戻す
      this.gridView.nativeElement.querySelector('.ag-header').style.display = 'block';
      // スクロールバーを再表示
      this.gridView.nativeElement.querySelector('.ag-body-viewport').style.overflow = 'auto';
      // フィルターの入力を可能にする
      var filterInput = this.gridView.nativeElement.querySelectorAll('.ag-header-cell input, .ag-header-cell button');
      for(let i in filterInput){
        if (filterInput.hasOwnProperty(i)) {
          filterInput[i].disabled = false;
        }
      }
    }

  waitResult(reporttrnId) {
    const obs = Observable.interval(1000).subscribe(() => {
      // Verify that we have not tried more than 10 times
      if (this.reportTry <= 10) {
        // Add a new try to the counter
        this.reportTry++;
        // Call the PDF report service
        this.pdfReportService
          .get(this.reporttrnId)
          .then(outputJson => {
            // If the createdFl is 0 the report has not finished so we retry again.
            // If the createdFl is 1 we get the report name and open a new window to show the PDF file.
            if (outputJson.reports[0].createdFl === 1) {
              // Cancel the Observable when success
              obs.unsubscribe();
              this.isShowSendLoading = false;
              const url = environment.bucketUrl + '/report/' + outputJson.reports[0].reportpathTx;
              // We open a new tab to display the PDF.
              // If preferred we could get the PDF data and send the blob to the new tab instead.
              this.openReport(url);
            }
            if (outputJson.reports[0].createdFl === -1) {
              // Cancel the Observable when success
              obs.unsubscribe();
              this.isShowSendLoading = false;
              this.errorInfo = 'データがありません。';
            }
          })
          .catch(error => {
            // Cancel the Observable in case of error
            obs.unsubscribe();
            // Change the working flag to false in order to enable the submit button
            this.isShowSendLoading = false;
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      } else {
        // Cancel the Observable if the number of tries maxed out
        obs.unsubscribe();
        // Change the working flag to false in order to enable the submit button
        this.isShowSendLoading = false;
        this.errorInfo = '帳票を取得できませんでした（タイムアウト）。再発する場合は管理者へ連絡してください';
      }
    });
  }

  // Open the newly generated report on a different tab/window
  openReport(url) {
    // Verify that the report has not been opened already in cases where the network response is slow
    // and we get multiple responses at the same time.
    if (this.reportOpened === false) {
      this.url = url;
      this.isShowRemoveModal = true;
      // Change the flag to indicate that the report was already opened
      this.reportOpened = true;
    }
    this.isShowSendLoading = false;
  }

  confirmOk() {
    const popup_window = window.open(this.url);
    try {
      popup_window.focus();
    } catch (e) {
      this.isShowRemoveModal = false;
      // this.dialogsService.customConfirm('エラー', 'ポップアップが許可されていません。PDFを開いて良い場合は、「PDFを開く」ボタンを押してください。', url, 'PDFを開く');
    }
  }


  changeTab(idx) {
    this.tabIndex = idx;
    if (this.postDataSource['querystrings']) {
      var newTypepickCd = idx === 0 ? '10' : '30';
      this.postDataSource['querystrings'] = Object.assign(
        {},
        this.postDataSource['querystrings'],
        { typepickCd: newTypepickCd }
      );
    }
    this.searchByKey({});
    this.selectedCount = 0;
  }

  onRowDataChanged() {
    this.gridHelper.onGridFilterChanged();
    this.gridHelper.onRowDataChanged();
  }

  //表示件数の変更
  paginatorRowChange() {
    this.gridOptions.cacheBlockSize = Number(this.rowsPerPage);
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    this.gridOptions.api.onSortChanged();
    localStorage.setItem('wa3030_rowsPerPage_idx', `${this.rowsPerPage}`);
  }

  //印刷可のみ表示をチェック
  onTab1CheckboxChanged() {
    this.filterGridByCheckbox();
  }

  filterGridByCheckbox() {
    var filters = {};
    if (!this.isTab1CheckboxChecked) {
      this.searchByKey({});
      return;
    }

    filters['stpickTx'] = {
      type: 'contains',
      filter: '印刷可'
    };
    this.searchByKey(filters);
  }

  onFilterClearTab1() {
    this.isTab1CheckboxChecked = false;
    this.onFilterClear();
  }

  clearAndSubmit() {
    this.onFilterClear();
  }

  showPrintOverlay() {
    this.errorInfo = '';
    var carrierCd = '';
    var ownerId = 0;
    let isPrintButtonEnabled = true;
    for (let i = 0; i < this.gridOptions.api.getSelectedRows().length; i++) {
      var data = this.gridOptions.api.getSelectedRows()[i];

      if (carrierCd === '') carrierCd = data['carrierCd'];
      else {
        if (carrierCd !== data['carrierCd']) isPrintButtonEnabled = false;
      }
      // check owner
      if (ownerId !== 0) {
        if (data['ownerId'] !== ownerId) {
          isPrintButtonEnabled = false;
        }
      } else {
        ownerId = data['ownerId'];
      }
    }
    this.isPrintClientReportBySelectedButtonEnabled = isPrintButtonEnabled;
  }

  onSearchBlockClick() {
    this.errorInfo = '';

    this.isShowSearchBlock = !this.isShowSearchBlock;
    this.gridHelper.renderScrollArrowDelay();
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }

  clrErr() {
    this.errorInfo = '';
  }

  // 全件ダウンロード
  exportAll(){

    //ボタン非活性
    this.isEnableRightAreaButtons = false;
    //ローディング表示
    this.isShowSendLoading = true;
    //処理中表示
    this.working = true;

    this.pickService
    .exportAllPick(this.ownerId)   
    .then(outputJson => {
      //console.log(outputJson.fileContents);

      const blob = new Blob(this.commonService.toSJis(outputJson.fileContents), {type: 'text/csv'});
      
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, outputJson.fileName);
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = outputJson.fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }

      this.isShowRemoveModal = false;
      this.isShowSendLoading = false;
      this.working = false;
    })    
    .catch(error => {
      this.isShowSendLoading = false;
      this.working = false;
      this.errorInfo = this.commonService.getErrorMessage(error);
      this.isEnableRightAreaButtons = true;
    });
  }

  /**
   * 全選択状態チェックボックスの状態を変更する
   */
  selectAllClick () {
    const startRow = (this.paginationGetCurrentPage - 1) * Number(this.rowsPerPage)
    const endRow = startRow + Number(this.rowsPerPage)
    const count = this.gridOptions.api.getDisplayedRowCount()

    let allSelected = true;
    for (let i = startRow; i < endRow; i++) {
      const node = this.gridOptions.api.getDisplayedRowAtIndex(i)
      if (node.data) {
        if (!node.isSelected()) {
          allSelected = false;
          break;
        }
      }
    }

    const selectAll = this.gridView.nativeElement.querySelector('.ag-header-row .ag-header-select-all');
    const hiddenCheckedElem = selectAll.querySelector('.ag-checkbox-checked.ag-hidden');
    console.log('hiddenCheckedElem, allSelected', hiddenCheckedElem, allSelected)
    if (allSelected) {
      // 行が全選択されている
      if (hiddenCheckedElem) {
        // 全選択チェックボックスは、非選択状態
        // なのでチェックボックスを選択状態にする（行を全て選択状態にするイベントは走らせない）
        this.selectAllModifyStatusOnleFlg = true;
        selectAll.click();
      }
    } else {
      // 行が全選択されていない
      if (!hiddenCheckedElem) {
        // 全選択チェックボックスは、選択状態
        this.selectAllModifyStatusOnleFlg = true;
        selectAll.click(); // チェックボックスを非選択状態にする（行を全て選択状態にするイベントは走らせない）
      }
    }
  }
  //*-- PostDataSource形式に変更したことにより追加 --//
  handleBeforeRequest () {
    this.gridOptions.api.showLoadingOverlay();
    this.setHeaderLoadingStart();
  }
  handleRequestSucc () {
    this.gridOptions.api.hideOverlay();
    this.setHeaderLoadingEnd();
    this.isShowSendLoading = false;
  }
  fixedDateFilterInput() {
    var dateFilter = this.gridView.nativeElement.querySelector('.ag-filter-filter');
    if (dateFilter == null) return;
    dateFilter.classList.add('ag-floating-filter-input');
    dateFilter.placeholder = '';
  }

  /**
   * 全選択ボタン初期化
   */
  fixedSelectAll() {
    const selectAll = this.gridView.nativeElement.querySelector('.ag-header-row .ag-header-select-all');
    selectAll.classList.remove('ag-hidden');
    selectAll.addEventListener('click', () => {

      // 現在のチェック状態を調べる
      const selectAllElem = this.gridView.nativeElement.querySelector('.ag-header-row .ag-header-select-all');
      const hiddenCheckedElem = selectAll.querySelector('.ag-checkbox-checked.ag-hidden');
      console.log('hiddenCheckedElem, allSelected', hiddenCheckedElem, selectAllElem)
      if (!this.selectAllModifyStatusOnleFlg) {
        if (hiddenCheckedElem) {
          // 非チェック状態
          this.selectCurrentPage(false)
        } else {
          // チェック状態
          this.selectCurrentPage(true)
        }
      }

      this.selectAllModifyStatusOnleFlg = false
    })
  }
  selectCurrentPage (selected) {
    const startRow = (this.paginationGetCurrentPage - 1) * Number(this.rowsPerPage)
    const endRow = startRow + Number(this.rowsPerPage)

    // this.gridOptions.api.forEachNode(node => {
    //   if (node.data)
    //     node.setSelected(false)
    // })
    const count = this.gridOptions.api.getDisplayedRowCount()
    const limit = count < endRow ? count : endRow

    for (let i = startRow; i < endRow; i++) {
      const node = this.gridOptions.api.getDisplayedRowAtIndex(i)
      if (node.data)
        node.setSelected(selected)
    }
  }

  //AGGrid ブロックキャッシュステータスチェック
  async checkCacheState(){
    const blockState = this.gridOptions.api.getCacheBlockState();
    let ret = false;
    //合計で10秒待つ
    for(let i = 0; i < 10; i++){
      if(blockState[0].pageStatus == RowNodeBlock.STATE_LOADED){
        return Promise.resolve;
      }
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
    return Promise.reject('AGGrid brockCache refresh timeout');
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3030/wa3030.component.ts